module.exports = __webpack_public_path__ + "static/media/cil-clock.544d8502.svg";